import MyOffers from 'features/rewards/screens/MyOffers/MyOffers';
import React from 'react';

export default function Page() {
  return <MyOffers />;
}
